import { render, staticRenderFns } from "./IconMusicNoteSolid.vue?vue&type=template&id=b962f28e"
import script from "./IconMusicNoteSolid.vue?vue&type=script&lang=js"
export * from "./IconMusicNoteSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports